var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "p-1" }, [
    _c(
      "header",
      { staticClass: "pb-1 d-flex justify-content-between align-items-start" },
      [
        _c("div", { staticClass: "d-flex column align-items-center" }, [
          _c(
            "span",
            { staticClass: "brand-logo mr-1" },
            [
              _c("b-img", {
                staticClass: "rounded",
                attrs: {
                  id: "logo",
                  src: _vm.style ? _vm.style.reducedHeaderImage : "",
                  alt: "logo",
                  fluid: "",
                },
              }),
            ],
            1
          ),
          _c("h1", { staticClass: "text-dark h1 mb-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("Expedição")) + " "),
          ]),
          _c("br"),
        ]),
        _vm.filter.storeId
          ? _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c("span", [_vm._v("Drive")]),
                _c("FormulateInput", {
                  staticClass: "ml-2 mt-1",
                  attrs: {
                    id: "pickup-point-switch",
                    type: "switch",
                    label: null,
                  },
                  on: { change: _vm.getData },
                  model: {
                    value: _vm.filter.pickupPoint,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "pickupPoint", $$v)
                    },
                    expression: "filter.pickupPoint",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.filter.storeId
          ? _c(
              "div",
              [
                _c("b-avatar", {
                  staticClass: "badge-minimal ml-1",
                  attrs: {
                    size: "40",
                    icon: "wifi",
                    variant: "light-primary",
                    badge: "",
                    "badge-variant": _vm.preparationWebSocketConnected
                      ? "success"
                      : "danger",
                    title: _vm.$t(
                      "Indica o status da conexão com a atualização dos pedidos de preparação"
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "link-primary",
                      title: _vm.$t("Atualizar lista de pedidos"),
                    },
                    on: { click: _vm.getData },
                  },
                  [
                    _c("b-icon", {
                      attrs: { icon: "arrow-clockwise", "font-scale": "1" },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "link-primary",
                      title: _vm.$t("Testar som"),
                    },
                    on: { click: _vm.testSound },
                  },
                  [
                    _c("b-icon", {
                      attrs: { icon: "volume-up", "font-scale": "1" },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.filter.storeId && _vm.isElectron
          ? _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c("span", [_vm._v("Imprimir pedido ao Iniciar Preparo")]),
                _c("FormulateInput", {
                  staticClass: "ml-2 mt-1",
                  attrs: {
                    id: "print-on-prepare-switch-global",
                    type: "switch",
                    label: null,
                  },
                  model: {
                    value: _vm.printOnPrepareGlobal,
                    callback: function ($$v) {
                      _vm.printOnPrepareGlobal = $$v
                    },
                    expression: "printOnPrepareGlobal",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { "min-width": "300px" } },
          [
            _c("e-store-combo", {
              attrs: {
                disabled: !_vm.ready,
                required: false,
                "show-label": false,
                clearable: true,
                placeholder: _vm.ready
                  ? _vm.$t("Selecione")
                  : _vm.$t("Aguarde..."),
              },
              on: { input: _vm.getData },
              model: {
                value: _vm.filter.storeId,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "storeId", $$v)
                },
                expression: "filter.storeId",
              },
            }),
          ],
          1
        ),
      ]
    ),
    !_vm.filter.storeId
      ? _c("div", { staticClass: "text-center" }, [
          _c("span", { staticClass: "h2" }, [
            _vm._v(" " + _vm._s(_vm.needSearchMessage)),
          ]),
        ])
      : _c("div", [
          _c("div", { staticClass: "kanban-board d-flex" }, [
            _c(
              "div",
              { staticClass: "kanban-column flex-fill mr-25" },
              [
                _c("h1", { staticClass: "text-center kanban-pending" }, [
                  _vm._v(" Aguardando "),
                ]),
                _vm._l(_vm.aguardandoOrders, function (order) {
                  return _c("preparation-order-card", {
                    key: order.id,
                    attrs: {
                      order: order,
                      "print-on-prepare": _vm.printOnPrepareGlobal,
                    },
                    on: { "update-status": _vm.handleUpdateStatus },
                  })
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "kanban-column flex-fill mr-25" },
              [
                _c("h1", { staticClass: "text-center kanban-preparing" }, [
                  _vm._v(" Preparando "),
                ]),
                _vm._l(_vm.preparandoOrders, function (order) {
                  return _c("preparation-order-card", {
                    key: order.id,
                    attrs: { order: order },
                    on: { "update-status": _vm.handleUpdateStatus },
                  })
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "kanban-column flex-fill" },
              [
                _c("h1", { staticClass: "text-center kanban-completed" }, [
                  _vm._v(" Pronto "),
                ]),
                _vm._l(_vm.prontoOrders, function (order) {
                  return _c("preparation-order-card", {
                    key: order.id,
                    attrs: { order: order },
                    on: { "update-status": _vm.handleUpdateStatus },
                  })
                }),
              ],
              2
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }